export default __webpack_public_path__ + "static/media/telugu_edu_m.0a0b3922.wav";